import { Component } from '@angular/core';
import { NavigationServiceOpen } from 'app/shared/navigation-open/navigation.service';

@Component({
    selector: 'app-public-access',
    templateUrl: 'public-access.component.html',
    styleUrls: ['public-access.component.scss']
})
export class PublicAccessComponent {
    title = 'app';
    constructor(private navigationServiceOpen: NavigationServiceOpen) {}
    showHamburgerMenu(): boolean {
        return this.navigationServiceOpen.showHamburgerMenu;
    }
}
